"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _table = _interopRequireDefault(require("antd/es/table"));
require("./style.sass");
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var Table = function Table(props) {
  var baseClass = 'sber-table';
  var theme = props.theme ? "".concat(baseClass, "_").concat(props.theme) : '';
  return /*#__PURE__*/_react.default.createElement(_table.default, _extends({
    showSorterTooltip: false
  }, props, {
    className: (0, _classnames.default)("".concat(baseClass, " ").concat(theme), props.className)
  }));
};
exports.Table = Table;
Table.propTypes = {
  theme: _propTypes.default.oneOf(['default', 'shadow'])
};